// extracted by mini-css-extract-plugin
export default {"teaSubscription":"TeaSubscription_teaSubscription__ZRdCl"};